import { Navigate, Outlet } from 'react-router-dom'

import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import FeedbackAlmostTherePage from './FeedbackAlmostTherePage'
import FeedbackBiggestChallengeIntroPage from './FeedbackBiggestChallengeIntroPage'
import FeedbackJoinHappyParentsPage from './FeedbackJoinHappyParentsPage'
import FeedbackNotAlonePage from './FeedbackNotAlonePage'
import FeedbackPetSafePlantsPage from './FeedbackPetSafePlantsPage'
import FeedbackSmartFeaturesPage from './FeedbackSmartFeaturesPage'
import FeedbackSmartWateringPage from './FeedbackSmartWateringPage'
import QuestionBiggestChallengePage from './QuestionBiggestChallengePage'
import QuestionCareRemindersPage from './QuestionCareRemindersPage'
import QuestionExperienceWithPlantsPage from './QuestionExperienceWithPlantsPage'
import QuestionHowManyPlantsPage from './QuestionHowManyPlantsPage'
import QuestionHowWaterPlantsPage from './QuestionHowWaterPlantsPage'
import QuestionLearnFirstPage from './QuestionLearnFirstPage'
import QuestionLightConditionPage from './QuestionLightConditionPage'
import QuestionMotivationPage from './QuestionMotivationPage'
import QuestionPetsAtHomePage from './QuestionPetsAtHomePage'
import QuestionPlantCareGoalPage from './QuestionPlantCareGoalPage'
import QuestionPlantLocationTypePage from './QuestionPlantLocationTypePage'
import QuestionPlantTypesInterestPage from './QuestionPlantTypesInterestPage'
import QuestionTimeDedicationPage from './QuestionTimeDedicationPage'
import QuestionWhereKeepPlantsPage from './QuestionWhereKeepPlantsPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="question-reason" replace />,
        index: true,
      },
      {
        element: <QuestionExperienceWithPlantsPage />,
        path: 'question-reason',
      },
      {
        element: <QuestionHowManyPlantsPage />,
        path: 'question-how-many-plants',
      },
      {
        element: <QuestionWhereKeepPlantsPage />,
        path: 'question-where-keep-plants',
      },
      {
        element: <QuestionLightConditionPage />,
        path: 'question-light-condition',
      },
      {
        element: <QuestionPlantLocationTypePage />,
        path: 'question-plant-location-type',
      },
      {
        element: <FeedbackBiggestChallengeIntroPage />,
        path: 'feedback-biggest-challenge-intro',
      },
      {
        element: <QuestionBiggestChallengePage />,
        path: 'question-biggest-challenge',
      },
      {
        element: <QuestionLearnFirstPage />,
        path: 'question-learn-first',
      },
      {
        element: <FeedbackNotAlonePage />,
        path: 'feedback-not-alone',
      },
      {
        element: <QuestionTimeDedicationPage />,
        path: 'question-time-dedication',
      },
      {
        element: <QuestionPlantTypesInterestPage />,
        path: 'question-plant-types-interest',
      },
      {
        element: <FeedbackSmartFeaturesPage />,
        path: 'feedback-smart-features',
      },
      {
        element: <QuestionPlantCareGoalPage />,
        path: 'question-plant-care-goal',
      },
      {
        element: <FeedbackJoinHappyParentsPage />,
        path: 'feedback-join-happy-parents',
      },
      {
        element: <QuestionHowWaterPlantsPage />,
        path: 'question-how-water-plants',
      },
      {
        element: <QuestionCareRemindersPage />,
        path: 'question-care-reminders',
      },
      {
        element: <FeedbackSmartWateringPage />,
        path: 'feedback-smart-watering',
      },
      {
        element: <QuestionPetsAtHomePage />,
        path: 'question-pets-at-home',
      },
      {
        element: <FeedbackPetSafePlantsPage />,
        path: 'feedback-pet-safe-plants',
      },
      {
        element: <QuestionMotivationPage />,
        path: 'question-motivation',
      },
      {
        element: <FeedbackAlmostTherePage />,
        path: 'feedback-almost-there',
      },
    ],
  },
]

export default onboardingRoutes
